import React from 'react';
import LogoIGPiG from '../../assets/logotypy/Logotyp_GPiG.webp';
import LogoKNG from '../../assets/logotypy/Logotyp_KNGPAN.webp';
import LogoEsri from '../../assets/logotypy/Logotyp_Esri_Polska.webp';
import LogoGisPlay from '../../assets/logotypy/Logotyp_GisPlay.webp'
import LogoGeoforum from '../../assets/logotypy/Logotyp_Geoforum.webp'
import LogoVimap from '../../assets/logotypy/Logotyp_Vimap.webp'
import LogoGeodetaolsztyn from '../../assets/logotypy/Logotyp_geodetaolsztyneu.webp';
import LogoEnviroSolutions from '../../assets/logotypy/Logotyp_EnviroSolutions.webp';
import LogoRadioUWM from '../../assets/logotypy/Logotyp_radio_UWM.webp';

import './right.css';

const Right = () => {
  return (
    <div className="giswnauce__right">
        <div className="giswnauce__right-event_organizer">
            <div className="event_organizer-header">
                <h1>Organizator</h1>
            </div>
            <div className="event_organizer-items">
                <a className="organizer-items-logo" href="https://uwm.edu.pl/igpig/" target="_blank" rel="noreferrer"><img src={ LogoIGPiG } alt="Instytut Gospodarki Przestrzennej i Geografii  Uniwersytetu Warmińsko-Mazurskiego w Olsztynie" /></a>
            </div>
        </div>
        <div className="giswnauce__right-event_organizer">
            <div className="event_organizer-header">
                <h1>Patronat</h1>
            </div>
            <div className="event_organizer-items">
                <a className="organizer-items-logo-esri" href="https://kngeo.pan.pl/" target="_blank" rel="noreferrer"><img src={ LogoKNG } alt="Komitet Nauk Geologicznych Polskiej Akademii Nauk" /></a>
            </div>
        </div>
        <div className="giswnauce__right-event_organizer">
            <div className="event_organizer-header">
                <h1>Patronat Technologiczny</h1>
            </div>
            <div className="event_organizer-items">
                <a className="organizer-items-logo-esri" href="https://www.esri.pl/" target="_blank" rel="noreferrer"><img src={ LogoEsri } alt="Esri Polska" /></a>
            </div>
        </div>
        <div className="giswnauce__right-event_organizer">
            <div className="event_organizer-header">
                <h1>Patronat Medialny</h1>
            </div>
            <div className="event_organizer-items">
                <a className="organizer-items-logo-esri" href="https://uwmfm.pl/" target="_blank" rel="noreferrer"><img src={ LogoRadioUWM } alt="Radio UWM FM" /></a>
            </div>
        </div>
        <div className="giswnauce__right-event_organizer">
            <div className="event_organizer-header">
                <h1>Partnerzy Wydarzenia</h1>
            </div>
            <div className="event_organizer-items">
                <a className="organizer-items-logo-esri" href="https://gisplay.pl/" target="_blank" rel="noreferrer"><img src={ LogoGisPlay } alt="gisplay.pl - portal geoinformacyjny" /></a>
            </div>
            <div className="event_organizer-items">
                <a className="organizer-items-logo-esri" href="https://geoforum.pl/" target="_blank" rel="noreferrer"><img src={ LogoGeoforum } alt="Geoforum" /></a>
            </div>
            <div className="event_organizer-items">
                <a className="organizer-items-logo-esri" href="https://www.vimap.pl/" target="_blank" rel="noreferrer"><img src={ LogoVimap } alt="Vimap Sp. z o.o." /></a>
            </div>
            <div className="event_organizer-items">
                <a className="organizer-items-logo-esri" href="https://geodetaolsztyn.eu/" target="_blank" rel="noreferrer"><img src={ LogoGeodetaolsztyn } alt="Geodeta Olsztyn - Usługi Geodezyjno-Kartograficzne" /></a>
            </div>
            <div className="event_organizer-items">
                <a className="organizer-items-logo-esri" href="https://envirosolutions.pl/" target="_blank" rel="noreferrer"><img src={ LogoEnviroSolutions } alt="EnviroSolutions: Systemy GIS i Szkolenia OpenSource" /></a>
            </div>
        </div>
    </div>
  )
}

export default Right